import { BORDERS, COLOR, CORNERS, INDENTS } from 'vars/index'

export const AvatarCorners = {
  CORNERS_0: CORNERS.CORNERS_0,
  CORNERS_20: CORNERS.CORNERS_20,
  CORNERS_ROUND: CORNERS.CORNERS_ROUND,
} as const
export type AvatarCorners = (typeof AvatarCorners)[keyof typeof AvatarCorners]

export const AvatarColors = {
  BACKGROUND_DARK: COLOR.BACKGROUND_DARK,
  SURFACE_OPACITY_LIGHT_15: COLOR.SURFACE_OPACITY_LIGHT_15,
  SURFACE_OPACITY_LIGHT_20: COLOR.SURFACE_OPACITY_LIGHT_20,
  ADDITIONAL_RED: COLOR.ADDITIONAL_RED,
  ADDITIONAL_ORANGE: COLOR.ADDITIONAL_ORANGE,
  ADDITIONAL_ORANGE_2: COLOR.ADDITIONAL_ORANGE_2,
  ADDITIONAL_BLUE_2: COLOR.ADDITIONAL_BLUE_2,
  ADDITIONAL_BLUE: COLOR.ADDITIONAL_BLUE,
} as const
export type AvatarColors = (typeof AvatarColors)[keyof typeof AvatarColors]

export const AvatarProfileColorList = [
  COLOR.ADDITIONAL_RED,
  COLOR.ADDITIONAL_ORANGE,
  COLOR.ADDITIONAL_ORANGE_2,
  COLOR.ADDITIONAL_BLUE_2,
  COLOR.ADDITIONAL_BLUE,
]

export const AvatarBorderColors = {
  ACCENT_TERTIARY: COLOR.ACCENT_TERTIARY,
  TEXT_ICON_PRIMARY: COLOR.TEXT_ICON_PRIMARY,
} as const
export type AvatarBorderColors =
  (typeof AvatarBorderColors)[keyof typeof AvatarBorderColors]

export const AvatarFonts = {
  Headline2: 'Headline2',
  Headline3: 'Headline3',
  Caption4: 'Caption4',
  Body4: 'Body4',
  Caption5: 'Caption5',
  FontXsBold: 'FontXsBold',
} as const
export type AvatarFonts = (typeof AvatarFonts)[keyof typeof AvatarFonts]

export const AvatarBorders = {
  BORDER_0: BORDERS.BORDER_0,
  BORDER_10: BORDERS.BORDER_10,
  BORDER_20: BORDERS.BORDER_20,
} as const
export type AvatarBorders = (typeof AvatarBorders)[keyof typeof AvatarBorders]

type PaddingKey = 'SIZE_0' | 'SIZE_20'
export const AvatarPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
    INDENTS.INDENT_0,
  ],
  SIZE_20: [
    INDENTS.INDENT_20,
    INDENTS.INDENT_20,
    INDENTS.INDENT_20,
    INDENTS.INDENT_20,
  ],
} as const
export type AvatarPadding = (typeof AvatarPaddings)[keyof typeof AvatarPaddings]

export const AvatarCursor = {
  Pointer: 'pointer',
} as const
export type AvatarCursor = (typeof AvatarCursor)[keyof typeof AvatarCursor]
